module.exports = __webpack_public_path__ + "img/partner13.68371fa1.png";